module.exports = __webpack_public_path__ + "static/media/aq.328821fe.svg";